<div class="accordion-group" [class.closed]="!isOpen">
  <div class="panel-heading" (click)="toggleOpen()"><ng-content select=".accordion__title"></ng-content></div>
  <div class="panel-collapse">
    <div class="panel-body"><ng-content select=".accordion__content"></ng-content></div>
  </div>
</div>
